'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import Networks from 'ads-account-connection/lib/Networks';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KnowledgeBaseLink from 'ads-account-connection/components/KnowledgeBaseLink';
import UILink from 'UIComponents/link/UILink';
import { CALYPSO } from 'HubStyleTokens/colors';
import { KBArticles } from 'ads-account-connection/lib/Constants';
const NETWORK_TO_KB_LINK = {
  [Networks.ADWORDS]: KBArticles.GOOGLE_ADS_TROUBLESHOOT,
  [Networks.FACEBOOK]: KBArticles.FACEBOOK_ADS_TROUBLESHOOT,
  [Networks.LINKEDIN]: KBArticles.LINKEDIN_ADS_TROUBLESHOOT
};
const NETWORK_INACTIVE_LINK = {
  [Networks.FACEBOOK]: accountId => `https://business.facebook.com/settings/ad-accounts/${accountId}`
};
export const PermissionsKBLink = ({
  network,
  children,
  onClick
}) => /*#__PURE__*/_jsx(KnowledgeBaseLink, {
  kbArticle: NETWORK_TO_KB_LINK[network],
  onClick: onClick,
  context: "account-missing-permissions",
  children: children
});

const InactiveLink = ({
  network,
  accountId,
  children,
  onClick
}) => {
  if (NETWORK_INACTIVE_LINK[network]) {
    // We don't pass through onClick here because that is used for KB
    // link click tracking, and this is no longer a KB link.
    return /*#__PURE__*/_jsx(UILink, {
      external: true,
      style: {
        color: CALYPSO
      },
      href: NETWORK_INACTIVE_LINK[network](accountId),
      children: children
    });
  }

  return /*#__PURE__*/_jsx(PermissionsKBLink, {
    network: network,
    onClick: onClick,
    children: children
  });
};

export const InactiveMessage = ({
  adAccount,
  hideName = false,
  onClick
}) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: `ADS_ACCOUNT_CONNECTION.permissions.${hideName ? 'inactive_account_no_name' : 'inactive_account'}.${adAccount.network}_jsx`,
  options: {
    network: adAccount.network,
    accountName: adAccount.getDisplayName(),
    onClick,
    accountId: adAccount.accountId
  },
  elements: {
    Link: InactiveLink,
    FixLink: PermissionsKBLink
  }
});
export const PermissionsMessage = ({
  network,
  adAccount,
  onClick
}) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "ADS_ACCOUNT_CONNECTION.permissions.needsRole_jsx",
  options: {
    networkDisplayName: I18n.text(`ADS_ACCOUNT_CONNECTION.networks.${adAccount.network.toLowerCase()}`),
    network,
    accountName: adAccount && adAccount.getDisplayName(),
    onClick
  },
  elements: {
    Link: PermissionsKBLink
  }
});